const SELECTORS = {
  BASES: 'html, body',
  BTN_CLOSE: '#SizingGuideBtnClose',
  BTN_OPEN: '#SizingGuideBtnOpen',
  WRAP: '#SizingGuideWrap',
  SIZING_GUIDE_TABLE: '.sizing-guide__table',
}

const KEYCODE_ESC = 27

const NO_SCROLL_CLASS = 'not-scrollable'
const SIZING_GUIDE_ACTIVE_CLASS = 'sizing-guide-wrap--is-active'

export default () => {

  $(SELECTORS.WRAP).off('click').on('click', (event) => {
    const userInteracting = Boolean($(event.target).closest(SELECTORS.SIZING_GUIDE_TABLE).length)
    if (!userInteracting) {
      close()
    }
  })

  $(SELECTORS.BTN_OPEN).on('click', () => open())

  $(SELECTORS.BTN_CLOSE).on('click', () => close())

  $(document).on('keyup.product', (event) => {
    if (event.which === KEYCODE_ESC && $(SELECTORS.WRAP).hasClass(SIZING_GUIDE_ACTIVE_CLASS)) {
      close()
    }
  })
}

function open() {
  $(SELECTORS.WRAP).addClass(SIZING_GUIDE_ACTIVE_CLASS)
  $(SELECTORS.BASES).addClass(NO_SCROLL_CLASS)
}

function close() {
  $(SELECTORS.WRAP).removeClass(SIZING_GUIDE_ACTIVE_CLASS)
  $(SELECTORS.BASES).removeClass(NO_SCROLL_CLASS)
}


// WEBPACK FOOTER //
// ./sizing-guide.js